module.exports = __webpack_public_path__ + "static/img/preview-05.80c1faf3.webp";